import {
  Select as BaseSelect,
  SelectItem as BaseSelectItem,
  SelectProps as BaseSelectProps,
  extendVariants,
} from '@heroui/react';
import * as React from 'react';
import { cn } from '@/utils';

const ExtendedSelect = extendVariants(BaseSelect, {
  variants: {
    color: {
      white: {
        trigger: 'bg-white data-[hover=true]:bg-background',
      },
    },
  },
});

type SelectProps<T extends object> = Omit<BaseSelectProps<T>, 'color'> & {
  color?: BaseSelectProps['color'] | 'white';
};

const Select = <T extends object>({ classNames, ...props }: SelectProps<T>) => {
  const mergedClassNames = {
    ...classNames,
    popoverContent: cn('!rounded-2xl', classNames?.popoverContent),
  };
  // `extendVariants` widens generics to `object`, so cast at the boundary.
  const Component = ExtendedSelect as unknown as React.FC<SelectProps<T>>;
  return <Component {...(props as SelectProps<T>)} classNames={mergedClassNames} />;
};

export { Select };
export const SelectItem = BaseSelectItem;
export type { SelectProps };
